import { db, admin } from "common/config/Firebase"
import createIds from "./createIds";

const indicatorsByDay = db.collection('indicatorsByDay')
const indicatorsByMonth = db.collection('indicatorsByMonth')

const updateTicket = (ticket, oldTicket) => {
    let increment = 0;
    
    if (ticket.paymentMode && !oldTicket.paymentMode) {
        increment = isNaN(ticket.totalPrice) ? 0 : Number(ticket.totalPrice)
    }

    else if (ticket.incorrect && !oldTicket.incorrect) {
        increment = isNaN(ticket.totalPrice) ? 0 : 0 - Number(ticket.totalPrice)
    }

    else if (!ticket.incorrect && oldTicket.incorrect) {
        increment = isNaN(ticket.totalPrice) ? 0 : Number(ticket.totalPrice)
    }

    else if (!ticket.paymentMode && oldTicket.paymentMode) {
        increment = isNaN(ticket.totalPrice) ? 0 : 0 - Number(oldTicket.totalPrice)
    }

    else if (ticket.paymentMode && (ticket.totalPrice !== oldTicket.totalPrice)) {
        const newTotal = isNaN(ticket.totalPrice) ? 0 : Number(ticket.totalPrice)
        const oldTotal = isNaN(oldTicket.totalPrice) ? 0 : Number(oldTicket.totalPrice)
        increment = newTotal - oldTotal
    }

    incrementAmount(new Date(ticket.ticketDate), increment)
}

const deleteTicket = (ticket) => {
    if (!ticket.paymentMode) {
        return
    }

    const increment = isNaN(ticket.totalPrice) ? 0 : 0 - Number(ticket.totalPrice)
    incrementAmount(new Date(ticket.ticketDate), increment)
}

const incrementAmount = (date, amount) => {
    if (!amount) {
        return
    }

    const increment = admin.firestore.FieldValue.increment(amount)
    try {
        indicatorsByDay.doc(createIds.createIdByDay(date)).set({ amountTicket: increment }, { merge: true })
        indicatorsByMonth.doc(createIds.createIdByMonth(date)).set({ amountTicket: increment }, { merge: true })
    } catch (ex) {
        console.error("Error al actualizar el indicatorsByDay")
    }
}

export default {
    updateTicket,
    deleteTicket
}
